import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import sensorType from '../types/sensor.type';
import modelEnum from '../../constants/model.enum';

export const getAllSensor = (data: any) => {
	return (dispatch: Dispatch) => {
		dispatch(getAllSensorStart());
		let url = URLConstants.GetAllSensor;
		services.post(url, data)
			.then(response => {
				dispatch(getAllSensorSuccess(response.data));
			})
			.catch(err => {
				dispatch(getAllSensorError(err));
			});
	};
};

export const getAllSensorFromIAQAervice = (data: any) => {
	return (dispatch: Dispatch) => {
		dispatch(getAllSensorStart());
		let url = URLConstants.GetAllSensor;
		services.post(url, data)
			.then(response => {
				dispatch(getAllSensorSuccess(response.data));
			})
			.catch(err => {
				dispatch(getAllSensorError(err));
			});
	};
};

const getAllSensorStart = () => {
	return {
		type: sensorType.GET_ALL_SENSOR_START
	};
};

const getAllSensorSuccess = (data: any) => {
	return {
		type: sensorType.GET_ALL_SENSOR_SUCCESS,
		payload: data
	};
};

const getAllSensorError = (data: any) => {
	return {
		type: sensorType.GET_ALL_SENSOR_ERROR,
		payload: data
	};
};

const deleteSensorStart = () => {
	return {
		type: sensorType.DELETE_SENSOR_START
	};
};

const deleteSensorSuccess = (data: any) => {
	return {
		type: sensorType.DELETE_SENSOR_SUCCESS,
		payload: data
	};
};

const deleteSensorError = (data: any) => {
	return {
		type: sensorType.DELETE_SENSOR_ERROR,
		payload: data
	};
};

const resetDeleteSensorDispatcher = () => {
	return {
		type: sensorType.RESET_DELETE_SENSOR_STATE
	};
};

export const resetDeleteSensorState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetDeleteSensorDispatcher());
	};
};


export const deleteSensor = (iccid: string) => {
	return (dispatch: Dispatch) => {
		dispatch(deleteSensorStart());
		let url = URLConstants.DeleteSensor + '/' + iccid;
		services.deleteapi(url)
			.then(response => {
				if (response.data)
					dispatch(deleteSensorSuccess(response.data));
				// else
				// 	dispatch(deleteSensorError('Message_Some_Error_Occured'));
			})
			.catch(err => {
				dispatch(deleteSensorError(err));
			});
	};
};

export const deleteIAQSensor = (iccid: string, isAdmin: boolean) => {
	return (dispatch: Dispatch) => {
		dispatch(deleteSensorStart());
		let url = URLConstants.DeleteIAQSensorLocation + '/' + iccid + '?isAdmin=' + isAdmin;
		services.deleteapi(url)
			.then(response => {
				if (response.data)
					dispatch(deleteSensorSuccess(response.data));
				// else
				// 	dispatch(deleteSensorError('Message_Some_Error_Occured'));
			})
			.catch(err => {
				dispatch(deleteSensorError(err));
			});
	};
};

const addSensorStart = () => {
	return {
		type: sensorType.ADD_SENSOR_START
	};
};

const addSensorSuccess = (data: any) => {
	return {
		type: sensorType.ADD_SENSOR_SUCCESS,
		payload: data
	};
};

const addSensorError = (data: any) => {
	return {
		type: sensorType.ADD_SENSOR_ERROR,
		payload: data
	};
};

const resetAddSensorDispatcher = () => {
	return {
		type: sensorType.RESET_ADD_SENSOR_STATE
	};
};

export const resetAddSensorState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetAddSensorDispatcher());
	};
};

export const addSensor = (id: number, data: any, isIAQ: boolean= false) => {
	return (dispatch: Dispatch) => {
		dispatch(addSensorStart());
		let sensorData: any;
		let url = URLConstants.UpdateSensor;
		if (id === -1) {
			url = URLConstants.AddSensor;
			sensorData = {
				Building: data.Building.trim(),
				Comments: data.Comments.trim(),
				CustomerID: data.CustomerId.trim(),
				Floor: data.Floor.trim(),
				ICCID: data.ICCID,
				Location: data.Location.trim(),
				Room: data.Room.trim(),
				UserID: Number(data.UserId),
				SendMail: data.SendMail
			}
		}
		else {
			sensorData = {
				Id: id,
				Building: data.Building.trim(),
				Comments: data.Comments.trim(),
				CustomerID: data.CustomerId.trim(),
				Floor: data.Floor.trim(),
				ICCID: data.ICCID,
				Location: data.Location.trim(),
				Room: data.Room.trim(),
				UserID: Number(data.UserId),
				SendMail: data.SendMail,
				IsIAQ: isIAQ
			}
		}
		services.post(url, sensorData)
			.then(response => {
				dispatch(addSensorSuccess(response.data));
			})
			.catch(err => {
				dispatch(addSensorError(err));
			});
	};
};


//Adding IAQ Sensor
export const addIAQSensor = (id: number, data: any, oldUserId: number,isIAQ: boolean= true) => {
	return (dispatch: Dispatch) => {
		dispatch(addSensorStart());
		let sensorData: any;
		let url = URLConstants.UpdateSensor;
		if (id === -1) {
			url = URLConstants.AddIAQSensor;
			sensorData = {
				Building: data.Building.trim(),
				Comments: data.Comments.trim(),
				CustomerID: data.CustomerId.trim(),
				Floor: data.Floor.trim(),
				ICCID: data.ICCID,
				Location: data.Location.trim(),
				Room: data.Room.trim(),
				UserID: Number(data.UserId),
				SendMail: data.SendMail,
				Model: modelEnum.IAQ.toLowerCase()
			}
		}
		else {
			sensorData = {
				Id: id,
				Building: data.Building.trim(),
				Comments: data.Comments.trim(),
				CustomerID: data.CustomerId.trim(),
				Floor: data.Floor.trim(),
				ICCID: data.ICCID,
				Location: data.Location.trim(),
				Room: data.Room.trim(),
				UserID: Number(data.UserId),
				SendMail: data.SendMail,
				IsIAQ: isIAQ,
				oldUserId: oldUserId
			}
		}
		services.post(url, sensorData)
			.then(response => {
				dispatch(addSensorSuccess(response.data));
			})
			.catch(err => {
				dispatch(addSensorError(err));
			});
	};
};

const getSensorByIdStart = () => {
	return {
		type: sensorType.GET_SENSOR_BY_ID_START
	};
};

const getSensorByIdSuccess = (data: any) => {
	return {
		type: sensorType.GET_SENSOR_BY_ID_SUCCESS,
		payload: data
	};
};

const getSensorByIdError = (data: any) => {
	return {
		type: sensorType.GET_SENSOR_BY_ID_ERROR,
		payload: data
	};
};

// const getSensorFilterStart = () => {
// 	return {
// 		type: sensorType.GET_SENSOR_FILTER_START
// 	};
// };

const getSensorFilterSuccess = (data: any) => {
	return {
		type: sensorType.GET_SENSOR_FILTER_SUCCESS,
		payload: JSON.parse(data)
	};
};

// const getSensorFilterError = (data: any) => {
// 	return {
// 		type: sensorType.GET_SENSOR_FILTER_ERROR,
// 		payload: data
// 	};
// };

const resetGetSensorByIdDispatcher = () => {
	return {
		type: sensorType.RESET_GET_SENSOR_BY_ID_STATE
	};
};

export const resetGetSensorByIdState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetGetSensorByIdDispatcher());
	};
};

export const setAddSensorIdByScanner = (data:any) =>{
	return (dispatch: Dispatch) => {
	dispatch(getSensorByIdSuccess(data));
		}
}
export const getSensorById = (iccid: string, IsIAQ: boolean = false) => {
	return (dispatch: Dispatch) => {
		dispatch(getSensorByIdStart());
		let url = URLConstants.GetSensorById + '/' + iccid + '/' + "?IsIAQ=" + IsIAQ?.toString();
		services.get(url)
			.then(response => {
				dispatch(getSensorByIdSuccess(response.data));
			})
			.catch(err => {
				dispatch(getSensorByIdError(err));
			});
	};
};

export const getSensorFilter = (iccid: string) => {
	return (dispatch: Dispatch) => {
		//dispatch(getSensorFilterStart());
		let sensorData = localStorage.getItem("SensonLocation.Filter");
		dispatch(getSensorFilterSuccess((sensorData)));
		// let url = URLConstants.GetSensorById + '/' + iccid;
		// services.get(url)
		// 	.then(response => {
		// 		let sensorData = localStorage.getItem("token1");
		// 		dispatch(getSensorFilterSuccess((sensorData)));
		// 	})
		// 	.catch(err => {
		// 		dispatch(getSensorFilterError(err));
		// 	});
	};
};


export const getUniqueBuilding = () => {
	return (dispatch: Dispatch) => {
		dispatch(getUniqueBuildingStart());
		let url = URLConstants.GetUniqueBuildingNames;
		services.get(url)
			.then(response => {
				dispatch(getUniqueBuildingSuccess(response.data));
			})
			.catch(err => {
				dispatch(getUniqueBuildingError(err));
			});
	};
};

const getUniqueBuildingStart = () => {
	return {
		type: sensorType.GET_SENSOR_BY_ID_START
	};
};

const getUniqueBuildingSuccess = (data: any) => {
	return {
		type: sensorType.GET_UNIQUE_BUILDING_SUCCESS,
		payload: data
	};
};

const getUniqueBuildingError = (data: any) => {
	return {
		type: sensorType.GET_UNIQUE_BUILDING_ERROR,
		payload: data
	};
};

const resetAllSensorStateDispatcher = () => {
	return {
		type: sensorType.RESET_ALL_SENSOR_STATE
	};
};

export const resetAllSensorState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetAllSensorStateDispatcher());
	};
};

export const allDevicesWithoutPagination = () => {
	return (dispatch: Dispatch) => {
		dispatch(getAllDevicesStart());
		let url = URLConstants.GetAllSensorDevicesWithoutPagination
		services.get(url)
			.then(response => {
				dispatch(getAllDevicesSuccess(response.data));
			})
			.catch(err => {
				dispatch(getAllDevicesError(err));
			});
	};
};

const resetAllDevicesStateDispatcher = () => {
	return {
		type: sensorType.RESET_ALL_DEVICES_STATE
	};
};

export const resetAllDevicesState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetAllDevicesStateDispatcher());
	};
};

const getAllDevicesStart = () => {
	return {
		type: sensorType.GET_ALL_DEVICES_START
	};
};

const getAllDevicesSuccess = (data: any) => {
	return {
		type: sensorType.GET_ALL_DEVICES_SUCCESS,
		payload: data
	};
};

const getAllDevicesError = (data: any) => {
	return {
		type: sensorType.GET_ALL_DEVICES_ERROR,
		payload: data
	};
};

//update device access addIAQSensor

export const updateDeviceAccess = (devicesData:any) => {
	return (dispatch: Dispatch) => {
		dispatch(updateDeviceAccessStart());
		let url = URLConstants.AddDeviceUserDetailsByUserId;
		const data = {
			UserId:devicesData.user.Id,
			DeviceDetails:devicesData.devices.map((device:any) => ({
				DeviceId:device.ID,
				ICCID:device.ICCID
			}))
		}
		services.post(url, data)
			.then(response => {
				dispatch(updateDeviceAccessSuccess(response.data));
			})
			.catch(err => {
				dispatch(updateDeviceAccessError(err));
			});
	};
};

const updateDeviceAccessStart = () => {
	return {
		type: sensorType.UPDATE_DEVICE_ACCESS_START
	};
};

const updateDeviceAccessSuccess = (data:any) =>{
	return {
		type:sensorType.UPDATE_DEVICE_ACCESS_SUCCESS,
		payload:data
	}
}

const updateDeviceAccessError = (data:any) => {
	return {
		type: sensorType.UPDATE_DEVICE_ACCESS_ERROR,
		payload:data
	}
}

const resetUpdateDeviceAccessDispatcher = () => {
	return {
		type: sensorType.RESET_UPDATE_DEVICE_ACCESS_STATE
	};
};

export const resetUpdateDeviceAccessState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetUpdateDeviceAccessDispatcher());
	};
};